import { Stack, Typography } from "@mui/material";
import type { JSX } from "react";

import { ValuationHubCoreModelRealEstateAddress } from "@/api/generatedApi";
import { formatFullAddress } from "@/helpers/formatStringHelpers";

interface TabHeaderWithAddressProps {
  label: string;
  address?: ValuationHubCoreModelRealEstateAddress | null;
}

export const TabHeaderWithAddress = ({ label, address }: TabHeaderWithAddressProps): JSX.Element => {
  return (
    <Stack alignItems={"start"} spacing={1} direction={"row"}>
      <Typography variant="tabLabel">{label}</Typography>
      {address && (
        <>
          <Typography variant="tabLabel">—</Typography>
          <Typography variant="tabLabel">{formatFullAddress(address)}</Typography>
        </>
      )}
    </Stack>
  );
};
